import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Typography,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  WhatshotIcon,
  FormHelperText,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  commonService,
  Radio,
  OutlinedInput,
  FormControlLabel,
  RadioGroup,
  KeyboardDatePicker,
  moment,
} from "../../../common";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3rem",
    padding: theme.spacing(3),
  },
  radioBtnStyle: {
    border: "1px solid #BEBDBD",
    width: "100%",
    borderRadius: "5px",

    "&$checked": {
      color: "yellow",
    },
  },
  error: {
    color: "#FF0F0F",
  },
  formLabel: {
    color: "#2B335E",
    fontSize: "1.25rem",
    letterSpacing: "0.23px",
    margin: "0 0 0 0.9375rem",
    "& span": {
      color: "#BEBDBD",
    },
  },
  radioGroup: {
    width: "100%",
    margin: "7px 0 0 17px",
  },
  radioGroupWrapper: { width: "100%", display: "flex" },
  customRadioStyle: {
    "&.root": {},
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  btnContainer: {
    paddingTop: "1rem",
  },
  divider: {
    marginTop: "3rem",
  },
}));

const GreenRadio = withStyles({
  root: {
    color: "#BEBDBD",
    "&$checked": {
      color: "#FC2861",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
let totalInputLengthArr = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];
export default function CreateReward() {
  const classes = useStyles();
  const [userType, setUserType] = useState([]);
  const [senderlevelType, setSenderLevelType] = useState([]);
  const [receiverlevelType, setReceiverLevelType] = useState([]);
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);

  const [sender, setSender] = useState("");
  const [receiver, setReceiver] = useState("");
  const [senderLevel, setSenderLevel] = useState("");

  const [receiverLevel, setReceiverLevel] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [currency, setCurrency] = useState("20");
  const [fromAmount, setFromAmount] = useState("");
  const [toAmount, setToAmount] = useState("");
  const [title, setTitle] = useState("");
  const [startingTime, setStartingTime] = useState("");
  const [endingTime, setEndingTime] = useState("");
  const [receiverAmount, setReceiverAmount] = useState("");
  const [senderSlabType, setSenderSlabType] = useState("");
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = useState({});
  const [remainingInputfield, setRemainingInputfield] = React.useState(13);
  const [totalInputfield, setTotalInputfield] = React.useState(13);
  const [loading, setLoading] = React.useState(false);

  const handleTransactionType = (e) => {
    setTransactionType(e.target.value);
    setErrors({});
    if (e.target.value !== "") {
      if (totalInputLengthArr[6] === false) {
        totalInputLengthArr[6] = true;
        setRemainingInputfield(remainingInputfield - 1);
      }
    } else {
      setRemainingInputfield(remainingInputfield + 1);
      totalInputLengthArr[6] = false;
    }
  };

  const changeStartingTime = (date) => {
    let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    setStartingTime(formattedDate);

    setErrors({});
    if (date !== "") {
      if (totalInputLengthArr[13] == false) {
        totalInputLengthArr[13] = true;
        setRemainingInputfield(remainingInputfield - 1);
      }
    } else {
      setRemainingInputfield(remainingInputfield + 1);
      totalInputLengthArr[13] = false;
    }
  };

  const changeEndingTime = (date) => {
    let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    setEndingTime(formattedDate);

    setErrors({});
    if (date !== "") {
      if (totalInputLengthArr[14] == false) {
        totalInputLengthArr[14] = true;
        setRemainingInputfield(remainingInputfield - 1);
      }
    } else {
      setRemainingInputfield(remainingInputfield + 1);
      totalInputLengthArr[14] = false;
    }
  };

  const handleSubmit = async () => {
    const rewardInfo = {
      title: title,
      sender_user_type_id: sender,
      receiver_user_type_id: receiver,
      sender_level_id: senderLevel,
      transaction_type_id: transactionType,
      sender_account_type_id: 1,
      currency_id: currency,
      from_amount: fromAmount,
      to_amount: toAmount,
      slab_type: senderSlabType,
      amount: receiverAmount,

      // receiver_slab_type: receiverSlabType,
      // receiver_charge: receiverAmount,
      receiver_level_id: receiverLevel,
      receiver_account_type_id: 1,
      starting_time: startingTime,
      ending_time: endingTime,
    };
    setLoading(true);
    if (handleError()) {
      const res = await commonService.createReward(rewardInfo);
      res?.code === 200 && setOpen(true);
      setLoading(false);
      setSuccessMsgBody("Receiver Reward Successfully Added.");
      setTimeout(() => {
        clearFormInput();
      }, 2000);
      res?.code !== 200 && setError(true);
      setLoading(false);
      setErrorMsgBody(res.messages[0]);
    } else {
      timer.current = window.setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleError = () => {
    let formIsValid = true;
    let errors = {};
    if (sender === "") {
      formIsValid = false;
      errors["sender"] = "Sender can't left empty.";
    }
    if (receiver === "") {
      formIsValid = false;
      errors["receiver"] = "Receiver can't left empty.";
    }
    if (senderLevel === "") {
      formIsValid = false;
      errors["senderLevel"] = "Sender Level can't left empty.";
    }
    if (receiverLevel === "") {
      formIsValid = false;
      errors["receiverLevel"] = "Receiver Level can't left empty.";
    }

    if (transactionType === "") {
      formIsValid = false;
      errors["transactionType"] = "Transaction Type can't left empty.";
    }
    if (currency === "") {
      formIsValid = false;
      errors["currency"] = "Currency can't left empty.";
    }
    if (fromAmount === "") {
      formIsValid = false;
      errors["fromAmount"] = "From Amount can't left empty.";
    }
    if (toAmount === "") {
      formIsValid = false;
      errors["toAmount"] = "To Amount can't left empty.";
    }
    if (senderSlabType === "") {
      formIsValid = false;
      errors["senderCharge"] = "Sender Slab Type can't left empty.";
    }

    if (title === "") {
      formIsValid = false;
      errors["title"] = "Title Type can't left empty.";
    }

    if (startingTime === "") {
      formIsValid = false;
      errors["startingTime"] = "Starting Time Type can't left empty.";
    }

    if (endingTime === "") {
      formIsValid = false;
      errors["endingTime"] = "Ending Time Type can't left empty.";
    }

    if (receiverAmount === "") {
      formIsValid = false;
      errors["receiverAmount"] = "Receiver Amount Type can't left empty.";
    }

    setErrors(errors);
    return formIsValid;
  };

  const clearFormInput = () => {
    setRemainingInputfield(13);
    setSender("");
    setReceiver("");
    setSenderLevel("");
    setReceiverLevel("");
    setCurrency("");
    setSenderSlabType("");
    setFromAmount("");
    setToAmount("");
    setTransactionType("");
    setReceiverAmount("");
    setStartingTime("");
    setEndingTime("");
    setTitle("");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const timer = React.useRef();

  const getUserTypes = async () => {
    const userType = await commonService.getUserType();
    setUserType(userType.data?.user_types);
  };

  const getCurrenciess = async () => {
    const currency = await commonService.getCurrencies();
    setCurrencyList(currency.data?.currencies);
  };

  useEffect(() => {
    getUserTypes();
    getCurrenciess();

    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const getTransactionTypeList = async (sender, receiver) => {
    const transactionType = await commonService.getTransactionTypeReward(
      sender,
      receiver
    );
    setTransactionTypeList(transactionType.data?.transaction_types);
  };

  const getSenderLevelsList = async (sender_user_type_id) => {
    const senderlevelType = await commonService.getLevel(sender_user_type_id);
    setSenderLevelType(senderlevelType.data?.levels);
  };

  const getReceiverLevelsList = async (receiver_user_type_id) => {
    const receiverlevelType = await commonService.getLevel(
      receiver_user_type_id
    );
    setReceiverLevelType(receiverlevelType.data?.levels);
  };

  return (
    <Grid xl={12} container className={classes.root}>
      {/* {console.log('totalInputLengthArr', totalInputLengthArr)} */}
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Grid item xl={12}>
        <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
          <NavLink color="inherit" to="/dashboard" className={classes.link}>
            <HomeIcon className={classes.icon} />
            Home
          </NavLink>
          <NavLink
            color="inherit"
            to="/receiver-reward/view-all"
            className={classes.link}
          >
            <WhatshotIcon className={classes.icon} />
            Receiver Reward
          </NavLink>
          <Typography color="textPrimary" className={classes.link}>
            Create
          </Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              textAlign: "left",
              margin: "15px 0",
              color: "#2B335E",
              fontSize: "25px",
            }}
          >
            Create Receiver Reward
          </Typography>

          <NavLink
            to="/receiver-reward/view-all"
            variant="contained"
            style={{ height: "30px", textDecoration: "none" }}
          >
            <Typography
              style={{
                color: "#2B335E",
                fontSize: "18px",
              }}
            >
              View Receiver Reward List
            </Typography>
          </NavLink>
        </div>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper style={{ padding: "20px", textAlign: "left" }}>
          <Grid container>
            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>Title</InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={12} xl={12}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="title"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Title
                      </InputLabel>
                      <OutlinedInput
                        labelId="demo-simple-select-filled-label"
                        label="title"
                        //    inputProps={{ maxLength: 14 }}
                        id="demo-simple-select-filled"
                        value={title}
                        name="title"
                        onChange={(e) => {
                          setTitle(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[12] == false) {
                              totalInputLengthArr[12] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[12] = false;
                          }
                        }}
                      ></OutlinedInput>
                      <FormHelperText className={classes.error}>
                        {errors["title"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>Parties</InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Sender is
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={sender}
                        name="sender"
                        onChange={(e) => {
                          setSender(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            getSenderLevelsList(e.target.value);
                            if (receiver !== "") {
                              getTransactionTypeList(e.target.value, receiver);
                            }
                            if (totalInputLengthArr[0] == false) {
                              totalInputLengthArr[0] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[0] = false;
                          }
                        }}
                        label="Sender is"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {userType.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["sender"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Receiver is
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={receiver}
                        name="receiver"
                        onChange={(e) => {
                          setReceiver(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            getReceiverLevelsList(e.target.value);
                            if (sender !== "") {
                              getTransactionTypeList(sender, e.target.value);
                            }
                            if (totalInputLengthArr[1] == false) {
                              totalInputLengthArr[1] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[1] = false;
                          }
                        }}
                        label="Receiver is"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {userType.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["receiver"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>Level</InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Sender is of
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={senderLevel}
                        onChange={(e) => {
                          setSenderLevel(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[2] == false) {
                              totalInputLengthArr[2] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[2] = false;
                          }
                        }}
                        label="Sender is of"
                        name="senderLevel"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {senderlevelType.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["senderLevel"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Receiver is of
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={receiverLevel}
                        onChange={(e) => {
                          setReceiverLevel(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[3] == false) {
                              totalInputLengthArr[3] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[3] = false;
                          }
                        }}
                        label="Receiver is of"
                        name="receiverLevel"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {receiverlevelType.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["receiverLevel"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>
                    Receiver Reward
                  </InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      component="fieldset"
                      className={classes.radioGroup}
                    >
                      {/* <FormLabel component="legend">Sender Charge</FormLabel> */}
                      <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                        <RadioGroup
                          row
                          aria-label="position"
                          name="senderCharge"
                          value={senderSlabType}
                          className={classes.radioGroupWrapper}
                          onChange={(e) => {
                            setSenderSlabType(e.target.value);
                            setErrors({});
                            if (e.target.value !== "") {
                              if (totalInputLengthArr[10] == false) {
                                totalInputLengthArr[10] = true;
                                setRemainingInputfield(remainingInputfield - 1);
                              }
                            } else {
                              setRemainingInputfield(remainingInputfield + 1);
                              totalInputLengthArr[10] = false;
                            }
                          }}
                        >
                          <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                            <FormControlLabel
                              value="P"
                              control={<GreenRadio />}
                              label="Percentage"
                              className={classes.radioBtnStyle}
                            />
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} lg={2} xl={2}></Grid>
                          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                            <FormControlLabel
                              value="F"
                              className={classes.radioBtnStyle}
                              control={<GreenRadio />}
                              label="Fixed"
                            />
                          </Grid>
                        </RadioGroup>
                      </Grid>
                      <FormHelperText className={classes.error}>
                        {errors["senderCharge"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="receiverAmount"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Receiver Amount
                      </InputLabel>
                      <OutlinedInput
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={receiverAmount}
                        name="receiverAmount"
                        inputProps={{ maxLength: 14 }}
                        label="Receiver Amount"
                        onChange={(e) => {
                          setReceiverAmount(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[11] == false) {
                              totalInputLengthArr[11] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[11] = false;
                          }
                        }}
                      ></OutlinedInput>
                      <FormHelperText className={classes.error}>
                        {errors["receiverAmount"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs="6">
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>Time</InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="startingTime"
                    >
                      <KeyboardDatePicker
                        style={{ margin: "0" }}
                        inputVariant="outlined"
                        disablePast
                        invalidDateMessage=""
                        margin="dense"
                        id="startingTime"
                        placeholder="Starting Time"
                        format="YYYY-MM-DD HH:mm:ss"
                        value={startingTime}
                        onChange={changeStartingTime}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />

                      <FormHelperText className={classes.error}>
                        {errors["startingTime"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="endingTime"
                    >
                      <KeyboardDatePicker
                        style={{ margin: "0" }}
                        inputVariant="outlined"
                        disablePast
                        invalidDateMessage=""
                        margin="dense"
                        id="endingTime"
                        placeholder="Ending Time"
                        format="YYYY-MM-DD HH:mm:ss"
                        value={endingTime}
                        onChange={changeEndingTime}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                      <FormHelperText className={classes.error}>
                        {errors["endingTime"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                {/* <Grid item container xs={12} spacing={1}>
                      <Grid item xs={6} xl={6}>
                        <InputLabel className={classes.formLabel}>
                          Transaction Type
                        </InputLabel>
                      </Grid>
                      <Grid item xs={6} xl={6}>
                        <InputLabel className={classes.formLabel}>
                          Currency
                        </InputLabel>
                      </Grid>
                    </Grid> */}
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid
                    item
                    container
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    spacing={1}
                  >
                    <InputLabel className={classes.formLabel}>
                      Transaction Type
                    </InputLabel>
                  </Grid>
                  <InputLabel className={classes.formLabel}>
                    Currency
                  </InputLabel>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Transaction Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={transactionType}
                        name="transactionType"
                        onChange={handleTransactionType}
                        label="Transaction Type"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {transactionTypeList.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["transactionType"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        Currency
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={currency}
                        onChange={(e) => {
                          setCurrency(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[7] == false) {
                              totalInputLengthArr[7] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[7] = false;
                          }
                        }}
                        label="Currency"
                        name="currency"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {currencyList.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </Select>
                      <FormHelperText className={classes.error}>
                        {errors["currency"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={1}
                >
                  {" "}
                  <InputLabel className={classes.formLabel}>
                    Transaction Amount
                  </InputLabel>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  spacing={2}
                >
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="from"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        From
                      </InputLabel>
                      <OutlinedInput
                        labelId="demo-simple-select-filled-label"
                        label="From"
                        inputProps={{ maxLength: 14 }}
                        id="demo-simple-select-filled"
                        value={fromAmount}
                        name="fromAmount"
                        onChange={(e) => {
                          setFromAmount(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[8] == false) {
                              totalInputLengthArr[8] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[8] = false;
                          }
                        }}
                      ></OutlinedInput>
                      <FormHelperText className={classes.error}>
                        {errors["fromAmount"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} xl={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      size="small"
                      id="sender"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        To
                      </InputLabel>
                      <OutlinedInput
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={toAmount}
                        inputProps={{ maxLength: 14 }}
                        onChange={(e) => {
                          setToAmount(e.target.value);
                          setErrors({});
                          if (e.target.value !== "") {
                            if (totalInputLengthArr[9] == false) {
                              totalInputLengthArr[9] = true;
                              setRemainingInputfield(remainingInputfield - 1);
                            }
                          } else {
                            setRemainingInputfield(remainingInputfield + 1);
                            totalInputLengthArr[9] = false;
                          }
                        }}
                        label="To"
                        name="toAmount"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {userType.map((user) => (
                          <MenuItem value={user.id}>{user.name}</MenuItem>
                        ))}
                      </OutlinedInput>
                      <FormHelperText className={classes.error}>
                        {errors["toAmount"]}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xl={12}
              md={12}
              sm={12}
              xs={12}
              lg={12}
              justify="space-between"
              alignItems="center"
              className={classes.divider}
            >
              {" "}
              <Divider style={{ margin: "20px 0", color: "#00000029" }} />
            </Grid>

            <Grid
              item
              container
              xl={12}
              justify="space-between"
              alignItems="center"
              className={classes.btnContainer}
            >
              <Grid item xl={6} md={6} sm={6} xs={6} lg={6}>
                {/* <Box ml={1}>
                  {remainingInputfield}/{totalInputfield} input remaining
                </Box> */}
              </Grid>
              <Grid
                item
                container
                xl={6}
                md={6}
                sm={6}
                xs={6}
                lg={6}
                justify="flex-end"
                alignItems="center"
              >
                <Box mr={5}>
                  <Button
                    variant="contained"
                    className={classes.cancelBtn}
                    onClick={clearFormInput}
                  >
                    CANCEL
                  </Button>
                </Box>
                <Box mr={1}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-block"
                    disabled={loading}
                  >
                    {loading && <CircularProgress size={17} />}
                    Create & add another
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
